import { render, staticRenderFns } from "./MensalidadeItensFatura.vue?vue&type=template&id=66ebc4f2&scoped=true"
import script from "./MensalidadeItensFatura.vue?vue&type=script&lang=js"
export * from "./MensalidadeItensFatura.vue?vue&type=script&lang=js"
import style0 from "./MensalidadeItensFatura.vue?vue&type=style&index=0&id=66ebc4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ebc4f2",
  null
  
)

export default component.exports